module.exports = __webpack_public_path__ + "img/ring_y_e_null_0.64969d8e.png";